import { RenderActivateContent } from './renderActivateContent'

export default function ServicesTwoColumnFooter({
  title,
  variant,
  buttonLink,
}) {
  return RenderActivateContent({ title, variant, buttonLink })
}
